import { formatPrice, calculatePerPersonCost, isWorkstationProduct } from '@/lib/utils';

export function ProductPricing({ product }) {
  return (
    <div>
      <p className="text-sm uppercase tracking-widest font-bold mb-3">PRICE</p>
      
      {/* MRP & Discount Badge */}
      {product.mrp && (
        <div className="flex items-center gap-4 mb-3">
          <span className="text-xl text-muted-foreground line-through">
            MRP {formatPrice(product.mrp)}
          </span>
          {product.discount_percent && (
            <span className="bg-accent text-accent-foreground px-4 py-2 text-sm font-black uppercase tracking-wider">
              SAVE {product.discount_percent}%
            </span>
          )}
        </div>
      )}
      
      {/* Selling Price */}
      <p className="mono text-5xl font-black text-primary mb-1" data-testid="product-price">
        {formatPrice(product.price)}
      </p>
      
      <p className="text-sm text-green-600 font-semibold mb-2">
        🚚 Free Shipping within Mumbai & Navi Mumbai
      </p>
      
      {/* Country of Origin */}
      <div className="flex items-center gap-2 bg-orange-50 border border-orange-200 px-3 py-2 rounded-md mb-3">
        <img 
          src="https://flagcdn.com/w40/in.png" 
          alt="India Flag"
          className="w-6 h-4 object-cover rounded-sm"
        />
        <span className="text-sm font-semibold text-gray-700">
          <strong>Country of Origin:</strong> India
        </span>
      </div>
      
      {product.mrp && (
        <p className="text-sm text-primary font-bold">
          You save {formatPrice(product.mrp - product.price)}!
        </p>
      )}
      
      {isWorkstationProduct(product.category) && (
        <div className="mt-3 p-4 bg-accent border-2 border-accent rounded-none">
          <p className="text-xs uppercase tracking-wider font-bold mb-2 text-accent-foreground">PER PERSON COST</p>
          <p className="mono text-3xl font-black text-primary" data-testid="per-person-cost">
            {formatPrice(calculatePerPersonCost(product.price, product.subcategory))}
          </p>
        </div>
      )}
    </div>
  );
}
